<template>
    <router-view/>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import { mapGetters } from 'vuex';

@Options({
    name:'HomeProgetti',
    components: {

    },
    computed: {
        ...mapGetters([
            'me',
        ])
    }
})
export default class HomeProgetti extends Vue {

}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
